import React, { useRef, useEffect, useState } from "react";
import _ from "lodash";
import debounce from "debounce-promise";
import moment from "moment";
import Draw from "./DesignationsDraw";
import ClaimDetailsTable from "./DesignationsTable";
import { wholeNumberWithCommas } from "../../utils/NumberFormatter";
import Notice from "../../Notice";
import Http from "../http";

// import RightArrow from "../../../public/placeholders/icon-arrow-right.svg";

const ReportsIndex = (props) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const currentMonth = new Date().getMonth();
  const selectMonth = currentMonth == 0 ? 11 : currentMonth - 1;
  const month = monthNames[selectMonth];
  const [notice, setNotice] = React.useState({
    kind: "error",
    open: false,
    message: "",
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entityID = urlParams.get("id");

  const [filterQuery, setFilterQuery] = useState({
    product_name: null,
    status: null,
  });
  const [searchQuery, setSearchQuery] = useState({
    id_340b: entityID ? entityID : props.entities[0].value,
    manufacturer: props.manufacturers[0].value,
    date_range: { start: moment().startOf("month").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") },
  });
  const [designations, setDesignations] = useState([]);
  const [isDesignationsLoading, setIsDesignationsLoading] = useState(false);

  const isMounted = useRef(false);

  useEffect(() => {
    fetch();
  }, [searchQuery]);

  useEffect(() => {
    if ((isMounted.current && !designations) || (isMounted.current && designations.length == 0)) {
      setNotice({
        kind: "success",
        open: true,
        message: "The current selection and filters returned no results",
      });
    }

    isMounted.current = true;
  }, [designations]);

  const fetch = async () => {
    setIsDesignationsLoading(true);
    await Http.fetchQuery(props.query_path, searchQuery).then((res) => {
      setDesignations(res.designations);
    });
    setIsDesignationsLoading(false);
  };

  const handleFilter = (name, value) => {
    setFilterQuery({ ...filterQuery, [name]: value });
  };

  const handleSearch = (name, value) => {
    setSearchQuery({ ...searchQuery, [name]: value });
  };

  const getFilters = () => {
    var filters = {};

    _.each(filterQuery, (value, key) => {
      if (value && value.length) _.assign(filters, { [key]: value });
    });

    return filters;
  };

  const filteredDesignations = () => {
    return _.filter(designations, getFilters());
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="content__container">
        <div className="page-details__container">
          <div className="page-details__container__info">
            <div className="page-details__title">Designations</div>
            <div className="breadcrumbs__container">
              <div className="breadcrumbs__crumb breadcrumbs__crumb__active">Reports</div>
            </div>
          </div>
          <div className="reports__grid" style={{ marginTop: 20 }}>
            <div className="div1">
              <div className="tile__well" style={{ height: "100%" }}>
                <div className="tile">
                  <div className="tile__header tile__header--spread">
                    <div className="t--md">Designations</div>
                  </div>
                  <div className="flex__container flex__container--align-center">
                    <div className="t-500 t--xl">{wholeNumberWithCommas(filteredDesignations()?.length)}</div>
                    <div className="t--sm ml-2">Total</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ClaimDetailsTable claims={filteredDesignations()} isLoading={isDesignationsLoading} />
      </div>
      <div className="draw__container">
        <Draw
          entities={props.entities}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          handleSearch={handleSearch}
          handleFilter={handleFilter}
          manufacturers={props.manufacturers}
          products={props.products}
        />
      </div>
      <Notice details={notice} />
    </div>
  );
};

export default ReportsIndex;
